exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumb-wrapper[data-v-337429e1]{margin-bottom:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-337429e1&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/MemberSale/MemberSaleDetail.vue
// module id = 488
// module chunks = 0